import * as http from '../utils/instance'

export const login = data => http.Post(`/WebApp/Login/GenToken`, data);

export const logout = LoginID => http.Post(`/WebApp/Login/LogOut?LoginID=${LoginID}`);

export const sendSMSCode = Account => http.Get(`/WebApp/Login/SendSMSCode?Account=${Account}`);

export const verifySMSCode = (VerifyCode, LoginID) => http.Get(`/WebApp/Login/VerifySMSCode?VerifyCode=${VerifyCode}&LoginID=${LoginID}`);

export const changePassword = (data) => http.Post(`/WebApp/Login/ChangePassword`, data);

export const verifyPassword = (Account, VerifyCode) => http.Get(`/WebApp/Login/VerifyPassword?VerifyCode=${VerifyCode}&Account=${Account}`);

export const startAccount = Account => http.Get(`/WebApp/Login/StartAccount?Account=${Account}`);

export const keepCurrentPassword= LoginID => http.Post(`/WebApp/Login/KeepCurrentPassword?LoginID=${LoginID}`);